import React from 'react';
import MatTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

type HeadRow = {
  id: string;
  align: 'left' | 'center' | 'right';
  disablePadding: boolean;
  label: string;
};

const headRows: HeadRow[] = [
  {
    id: 'id',
    align: 'center',
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'hub_type',
    align: 'center',
    disablePadding: true,
    label: 'Hub Type',
  },
  {
    id: 'lock_type',
    align: 'center',
    disablePadding: true,
    label: 'Lock Type',
  },
  {
    id: 'serial_number',
    align: 'center',
    disablePadding: true,
    label: 'Serial number',
  },
  {
    id: 'property_id',
    align: 'center',
    disablePadding: true,
    label: 'Property ID',
  },
  {
    id: 'action',
    align: 'center',
    disablePadding: true,
    label: 'Action',
  },
  {
    id: 'created_on',
    align: 'center',
    disablePadding: true,
    label: 'Timestamp',
  },
  {
    id: 'created_by',
    align: 'center',
    disablePadding: true,
    label: 'User',
  },
  {
    id: 'created_by_email',
    align: 'center',
    disablePadding: true,
    label: 'User email',
  },
];

const DeviceActivationLogsTableHead = () => (
  <MatTableHead>
    <TableRow>
      {headRows.map(item => (
        <TableCell
          key={item.id}
          align={item.align}
          padding={item.disablePadding ? 'none' : 'default'}
        >
          {item.label}
        </TableCell>
      ))}
    </TableRow>
  </MatTableHead>
);

export default React.memo(DeviceActivationLogsTableHead);
